import { useClubLogo } from '../lib/useClubLogo';
import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, Shield } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from '../components/ui/sheet';



const navLinks = [
  { label: 'Start', href: '/#hero' },
  { label: 'Spiele', href: '/#spiele' },
  { label: 'Kader', href: '/kader' },
  { label: 'Verein', href: '/#verein' },
  { label: 'Kontakt', href: '/#kontakt' },
];

export default function Navbar() {
  const LOGO_URL = useClubLogo();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const handleNavClick = (href) => {
    setOpen(false);
    if (href.startsWith('/#')) {
      const id = href.substring(2);
      if (location.pathname === '/') {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      } else {
        window.location.href = '/' + href.substring(1);
      }
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-[hsl(0,0%,5%)]/95 backdrop-blur supports-[backdrop-filter]:bg-[hsl(0,0%,5%)]/80 border-b border-white/10" data-testid="navbar">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-3 group" data-testid="nav-logo">
            <div className="w-10 h-10 rounded-full overflow-hidden bg-[hsl(0,0%,12%)] flex-shrink-0">
              <img src={LOGO_URL} alt="Dresden Devils Logo" className="w-full h-full object-contain rounded-full" style={{ background: '#141414' }} />
            </div>
            <div className="hidden sm:block">
              <span className="font-bold text-white text-lg" style={{ fontFamily: 'Space Grotesk' }}>DRESDEN</span>
              <span className="font-bold text-[#CC0000] text-lg ml-1" style={{ fontFamily: 'Space Grotesk' }}>DEVILS</span>
            </div>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              link.href.startsWith('/#') ? (
                <button key={link.label} onClick={() => handleNavClick(link.href)}
                  className="px-3 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 rounded-lg transition-colors duration-200 uppercase tracking-wider font-medium"
                  style={{ fontSize: '12px' }} data-testid={`nav-${link.label.toLowerCase()}-link`}>
                  {link.label}
                </button>
              ) : (
                <Link key={link.label} to={link.href}
                  className="px-3 py-2 text-sm text-white/70 hover:text-white hover:bg-white/5 rounded-lg transition-colors duration-200 uppercase tracking-wider font-medium"
                  style={{ fontSize: '12px' }} data-testid={`nav-${link.label.toLowerCase()}-link`}>
                  {link.label}
                </Link>
              )
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <Link to="/admin" className="p-2 text-white/40 hover:text-white/70 hover:bg-white/5 rounded-lg transition-colors duration-200" data-testid="nav-admin-link" title="Admin">
              <Shield className="w-5 h-5" />
            </Link>
            <Sheet open={open} onOpenChange={setOpen}>
              <SheetTrigger asChild className="md:hidden">
                <button className="p-2 text-white/80 hover:text-white" data-testid="nav-mobile-menu">
                  <Menu className="w-6 h-6" />
                </button>
              </SheetTrigger>
              <SheetContent side="right" className="bg-[hsl(0,0%,5%)] border-white/10 w-72">
                <div className="flex flex-col gap-2 mt-8">
                  <div className="flex items-center gap-3 mb-6 px-4">
                    <div className="w-12 h-12 rounded-full overflow-hidden bg-[hsl(0,0%,12%)]">
                      <img src={LOGO_URL} alt="Logo" className="w-full h-full object-contain rounded-full" style={{ background: '#141414' }} />
                    </div>
                    <div>
                      <div className="font-bold text-white" style={{ fontFamily: 'Space Grotesk' }}>DRESDEN DEVILS</div>
                      <div className="text-xs text-white/40">EHV e.V.</div>
                    </div>
                  </div>
                  {navLinks.map((link) => (
                    link.href.startsWith('/#') ? (
                      <button key={link.label} onClick={() => handleNavClick(link.href)}
                        className="px-4 py-3 text-left text-lg text-white/80 hover:text-white hover:bg-white/5 rounded-lg transition-colors duration-200">
                        {link.label}
                      </button>
                    ) : (
                      <Link key={link.label} to={link.href} onClick={() => setOpen(false)}
                        className="px-4 py-3 text-lg text-white/80 hover:text-white hover:bg-white/5 rounded-lg transition-colors duration-200">
                        {link.label}
                      </Link>
                    )
                  ))}
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
}
